import { rest as API } from './rest';

const basePath = ({ customerUUID, ecosystemUUID }) =>
  `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/gateways`;

export const getGatewaysList = (params) => API.get(basePath(params)).then(({ data }) => data);

export const getGatewayDetail = (params) => API.get(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);

export const createGateway = (params) => API.post(basePath(params), params.payload).then(({ data }) => data);

export const updateGateway = (params) =>
  API.put(`${basePath(params)}/${params.uuid}`, params.payload).then(({ data }) => data);

export const deleteGateway = (params) => API.delete(`${basePath(params)}/${params.uuid}`).then(({ data }) => data);

export const getGatewayPlatforms = (params) =>
  API.get(`${basePath(params)}/${params.uuid}/platforms`).then(({ data }) => data);

export const generatePSK = (params) =>
  API.post(`${basePath(params)}/${params.uuid}/psk`, params.payload).then(({ data }) => data);

export const generateToken = (params) =>
  API.post(`${basePath(params)}/${params.uuid}/token`, params.payload).then(({ data }) => data);

export const getConfigLink = ({ token, platform }) =>
  `${process.env.REACT_APP_API_URL}/v2/gateways/ipsec/config/${platform}?_token=${token}`;
